import { Typography } from '@mui/material';

const BOOKING_STATUS_LABELS: Record<string, string> = {
  CONFIRMED: 'Confirmed',
  TENTATIVE: 'Tentative',
  WAITLISTED: 'Waitlisted',
  ENQUIRY: 'Enquiry',
  AWAITING_CONFIRMATION: 'Awaiting Confirmation',
};

export const optionValue = (value: any) => {
  if (value == null || value === '') return value;
  if (typeof value === 'object') return value.value;
  return value;
};

export const optionLabel = (value: any) => {
  if (value == null || value === '') return '';
  if (typeof value === 'object') return value.label ?? '';
  return String(value);
};

export const formatIdsBookingStatus = (label?: string | null) => {
  if (!label) return '—';
  return BOOKING_STATUS_LABELS[label] || label.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
};

export const stackedIdsCell = (name?: string | null, code?: string | null) => (
  <>
    <Typography sx={{ fontSize: '0.8125rem', fontWeight: 600, lineHeight: 1.35 }}>{name || '—'}</Typography>
    {code != null && String(code).trim() !== '' ? (
      <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', lineHeight: 1.35 }}>Code: {code}</Typography>
    ) : null}
  </>
);
